import { IResponseBaseTDto } from '@sprytki-frontend-apps/common';
import { ILockerGateItem } from 'api/interfaces/lockerGate';
import { apiClient } from './apiClient';
import { ILocationConfiguration } from 'api/interfaces/location';
import { ICCTVUrlDto, ICCTVUrlQueryParams } from 'api/interfaces/cctv';

const LOCATIONS = 'locations';

export const LocationServiceAPI = {
	getLockersAndGatesWithAlerts: async (id: string): Promise<IResponseBaseTDto<ILockerGateItem[]>> => {
		const response = await apiClient.get(`${LOCATIONS}/${id}/lockersAndGates`);
		return response.data;
	},
	getLocationDetails: async (id: string): Promise<IResponseBaseTDto<ILocationConfiguration>> => {
		const response = await apiClient.get(`${LOCATIONS}/${id}`);
		return response.data;
	},
	getCCTVUrl: async (id: string, queryParams?: ICCTVUrlQueryParams): Promise<IResponseBaseTDto<ICCTVUrlDto>> => {
		const response = await apiClient.get(`${LOCATIONS}/${id}/cctv-url`, { params: queryParams });
		return response.data;
	},
};
